<template>
  <button type="button" class="btn-success">
    <i v-if="icon" :class="icon" />
    <span v-if="icon" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "SuccessButton",
  props: ["label", "icon"],
};
</script>